import React, { Component } from 'react';

class Error404 extends Component {
	constructor(){
		super();
		this.state={
		};
	}

	goBack(e){
		e.preventDefault();
		window.history.back();
	}

  	render(){

		// let error = {code:'404' , message : '' };
		// if(typeof this.props.obj !== 'undefined'){
		// 	error = {...error, code:this.props.obj.code,message:this.props.obj.error};
		// }
		return(
			<section className="content">
			<div className="error-page">
			  <h2 className="headline text-warning"> 404</h2>
	  
			  <div className="error-content">
				<h3><i className="fas fa-exclamation-triangle text-warning"></i> Oops! Page not found.</h3>
	  
				<p>
				  We could not find the page you were looking for.
				  Meanwhile, you may <a href="../../index.html">return to dashboard</a> or try using the search form.
				</p>
	  
				<form className="search-form">
				  <div className="input-group">
					<input type="text" name="search" className="form-control" placeholder="Search" />
	  
					<div className="input-group-append">
					  <button type="submit" name="submit" className="btn btn-warning"><i className="fas fa-search"></i>
					  </button>
					</div>
				  </div>
				</form>
			  </div>
			</div>
		  </section>
		);
	}
}

export default Error404;
